import React, {Component} from 'react';
import {ListDesignerProvider} from "../../ContextComponents/ListDesignerContext";
import request from "../../Services/API/Requests";
import getSafe from "../JsonScreen/Utils/getSafeValues";
import {Loading} from "../../Utils/Loading/Loading";
import ToolBar from "./ToolBar/ToolBar";
import ScreenBar from "./ScreenBar/ScreenBar";
import withStyles from "@material-ui/core/styles/withStyles";
import {set, push} from 'object-path-immutable'
import Confirmation from "../../Utils/Confirmation/Confirmation";
import {makePivotData} from "../../Utils/ListUtils/generatePivotData";
import {makePivotColumns} from "../../Utils/ListUtils/generatePivotColumns";
import _ from 'lodash';
import {withSnackbar} from "notistack";
import deepmerge from "deepmerge";
import {transposeDataColumns} from "../../Utils/ListUtils/transposeData";
import {successMessage} from "../JsonScreen/Utils";
import {checkDataSource} from "./ToolBar/Panels/DataSource/DataSource";

const styles = () => ({
    rootPaper: {
        display: 'flex',
        height: '100%'
    },
    screenBarWrapper: {
        width: '100%',
        height: '100%',
        marginLeft: 5
    }
});


class ListDesigner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            schema: {},
            currentSerie: null,
            data: {
                source: {
                    paged: true
                },
                gridProps: {
                    hideListHeader: false,
                    hideListFooter: false,
                    hideColumnHeader: false,
                    sortable: false,
                    selectable: false,
                    exportable: false,
                    showCountSelected: false,
                    sumSelectedFields: []
                },
                devSettings: {
                    isAll: false,
                    logQuery: false,
                    previewRows: 25,
                },
                chartProps: {
                    enableGridX: true,
                    enableGridY: true,
                    lineStyle: "linear",
                    enableLabel: false,
                    axisX: {
                        enable: true,
                        interval: "0",
                        position: "bottom",
                        tickRotation: "0",
                        labelOffset: "0"
                    },
                    axisY: {
                        enable: true,
                        interval: "0",
                        position: "left",
                        tickRotation: "0",
                        labelOffset: "0"
                    },
                    legend: {
                        enable: true,
                        position: 'right',
                        direction: 'vertical',
                        verticalAlign: 'middle',
                        translateX: "20",
                    },
                    title: {
                        styles: {}
                    }
                }
            },
            columns: [],
            listData: [],
            pivotData: [],
            pivotGeneratedColumns: [],
            loading: false,
            loadingData: false,
            isChanged: false,
            loadedSampleData: false,
            confirmationDialog: {
                open: false,
                text: '',
                submitLabel: '',
                cancelLabel: '',
                submitFn: null,
                cancelFn: null,
            },
        };
        this.getListData = this.getListData.bind(this);
        this.updateListData = this.updateListData.bind(this);
        this.getColumns = this.getColumns.bind(this);
        this.loadSampleData = this.loadSampleData.bind(this);
    }

    async componentDidMount() {
        this.setState({loading: true});
        await this.getSchema();
        await this.getData();
        this.setState({loading: false});
        // await this.getListData();
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        const {match: {params: {id: prevId} = {}} = {}} = prevProps;
        const {match: {params: {id} = {}} = {}} = this.props;
        const {loadedSampleData: prevLoadedSampleData} = prevState;
        const {loadedSampleData} = this.state;
        if (prevId !== id) {
            if (!id) {
                await this.getSchema();
                this.setState({
                    currentSerie: null,
                    data: {
                        source: {
                            paged: false
                        },
                        gridProps: {
                            hideListHeader: false,
                            hideListFooter: false,
                            hideColumnHeader: false,
                            sortable: false,
                            selectable: false,
                            exportable: false,
                            showCountSelected: false,
                            sumSelectedFields: []
                        },
                        devSettings: {
                            isAll: false,
                            logQuery: false,
                            previewRows: 25,
                        },
                        chartProps: {
                            enableGridX: true,
                            enableGridY: true,
                            lineStyle: "linear",
                            enableLabel: false,
                            axisX: {
                                enable: true,
                                interval: "0",
                                position: "bottom",
                                tickRotation: "0",
                                labelOffset: "0"
                            },
                            axisY: {
                                enable: true,
                                interval: "0",
                                position: "left",
                                tickRotation: "0",
                                labelOffset: "0"
                            },
                            legend: {
                                enable: true,
                                position: 'right',
                                direction: 'vertical',
                                verticalAlign: 'middle',
                                translateX: "20",
                            },
                            title: {
                                styles: {}
                            }
                        }
                    },
                    columns: [],
                    listData: [],
                    pivotData: [],
                    pivotGeneratedColumns: [],
                    loading: false,
                    isChanged: false,
                })
                return
            }
            await this.getSchema();
            await this.getData();
            await this.getListData();
        }
        //load sample data (for "sbEntity" connector)
        if(loadedSampleData !== prevLoadedSampleData && loadedSampleData) {
            await this.getListData();
        }
    }

    componentDidCatch(error, errorInfo) {
        if (error) {
            this.setState({errorComponent: true});
            console.log(error, '\n', errorInfo)
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            nextProps.drawerWidth === this.props.drawerWidth
        )
    }

    async getSchema() {
        const {enqueueSnackbar} = this.props;

        try {
            const schema = await request({
                url: 'schema/read',
                data: {id: 'list'},
                method: 'POST'
            });
            this.setState({schema: schema.properties});
        } catch (err) {
            this.setState({loading: false});
            const errMessage = getSafe(() => err.data.status.message[0].text, 'Get schema error!');
            enqueueSnackbar(errMessage, {variant: 'error'});
        }
    }

    async getData() {
        const {
            location: {state: {fieldValuesId} = {}} = {},
            match: {params: {id} = {}} = {},
            predefinedListValues,
            enqueueSnackbar
        } = this.props;
        const {data: initialData} = this.state;
        const recordId = id ? id : fieldValuesId ? fieldValuesId : null;
        if (recordId) {
            try {
                const data = await request({
                    url: "list/read",
                    data: {id: recordId},
                    method: "POST"
                });

                //set first available serie color
                let mergedData = deepmerge(initialData, data); //set default values from state
                this.setState(() => ({data: mergedData}), async () => {
                    await this.getListData();
                    await this.getColumns(data.source)
                })
            } catch (err) {
                this.setState({loading: false});
                const errMessage = getSafe(() => err.data.status.message[0].text, 'Get data error!');
                enqueueSnackbar(errMessage, {variant: 'error'});
                console.log(err)
            }
        } else {
            if (predefinedListValues) {
                let data = {id: predefinedListValues.id, name: predefinedListValues.name};
                let mergedData = deepmerge(initialData, data);
                this.setState({data: mergedData, loading: false})
            } else {
                this.setState({loading: false})
            }
        }

    }

    async getListData() {
        const {
            location: {state: {fieldValuesId} = {}} = {},
            match: {params: {id} = {}} = {},
            enqueueSnackbar
        } = this.props;
        const {data: {devSettings: {previewRows}}, data, loadedSampleData} = this.state;
        let currentConnector = data?.source?.inPlaceConnection?.connector;

        const recordId = id ? id : fieldValuesId ? fieldValuesId : null;

        //do not load if connector "sbEntity"
        if (this.state.data.presentation === 'chart' || recordId && (currentConnector !== 'sbEntity' || loadedSampleData)) {
            try {
                this.setState({loadingData: true});
                const listData = await request({
                    url: "list/getData",
                    data: {id: recordId, pageSize: previewRows},
                    method: "POST"
                });
                let generatedData = await this.setListData(listData, previewRows);
                this.setState({
                    //columns: generatedData.listColumns,
                    loadingData: false,
                    initialData: listData,
                    listData: {...listData, ...generatedData.content},
                    pivotData: generatedData.pivotData,
                    pivotGeneratedColumns: generatedData.pivotColumns
                })
            } catch (err) {
                this.setState({loadingData: false});
                const errMessage = getSafe(() => err.data.status.message[0].text, 'Get Data Error!');
                enqueueSnackbar(errMessage, {variant: 'error'});
                console.log(err)
            }
        }else {
            this.setState({loadingData: false})
        }
    }

    setListData = async (listData = {}, previewRows) => {
        const {data: {rows, values, pivotColumns: pivotCols, columns, transposeData}} = this.state;
        let content = listData.content ? listData.content.slice(0, previewRows) : [];
        let listColumns = columns;
        let pivotData = [];
        let pivotColumns = [];
        if (transposeData) {
            const transposedData = transposeDataColumns(content, columns);
            pivotData = transposedData.newData;
            pivotColumns = transposedData.newColumns;
        }

        //pivot logic
        if (!_.isEmpty(rows) && !_.isEmpty(values)) {
            pivotColumns = makePivotColumns(content, rows, values, pivotCols, listColumns);
            pivotData = makePivotData(content, rows, values, pivotCols, listColumns, pivotColumns);
        }
        return {content, listColumns, pivotColumns, pivotData}
    };

    async getQueryColumns() {
        const {enqueueSnackbar} = this.props;
        try {
            const listData = await request({
                url: "list/getData",
                data: {list: this.state.data},
                method: "POST"
            });
            this.setState({loading: false});
            let firstRecord = listData.content[0];
            let columns = [];
            Object.keys(firstRecord || {}).forEach(key => {
                let type = typeof firstRecord[key] === 'object' ? 'string' : typeof firstRecord[key];
                columns.push(
                    {name: key, label: key, type: type}
                )
            });
            this.setState({columns})
        } catch (err) {
            this.setState({loading: false});
            const errMessage = getSafe(() => err.data.status.message[0].text, 'Get Columns Error!');
            enqueueSnackbar(errMessage, {variant: 'error'});
            console.log(err)
        }
    }

    async getColumns(source = {}) {
        const {data} = this.state;
        const {enqueueSnackbar} = this.props;
        let dataSource = await checkDataSource(data.id);
        try {
            if (dataSource) {
                const response = await request({
                    url: "/dataSource/getColumns",
                    data: {
                        id: data.id
                    }
                })
                this.setState({columns: response})
                return;
            }

            const response = await request({
                url: "list/getColumns",
                data: {...source}
            });
            this.setState({columns: response})
        } catch (e) {
            enqueueSnackbar('get columns error', {variant: 'error'});
        }

        // switch (source.type) {
        //     case 'ENTITY':
        //         return await this.getEntityColumns(source.entity);
        //     case 'ROUTINE':
        //         return await this.getRoutineColumns(source.routine);
        //     case 'QUERY':
        //         return await this.getQueryColumns();
        //     default:
        //         return enqueueSnackbar('No source', {variant: 'error'});
        // }
    }

    async updateListData() {
        const {enqueueSnackbar} = this.props;
        const {data, data: {devSettings: {previewRows}}, loadedSampleData} = this.state;
        let currentConnector = data?.source?.inPlaceConnection?.connector;

        //do not load if connector "sbEntity"
        if(currentConnector !== 'sbEntity' || loadedSampleData){
            try {
                this.setState({loading: true});
                let dataSource = await checkDataSource(data.id);

                if (!dataSource) {
                    dataSource = await request({
                        url: "/dataSource/create",
                        data: {
                            id: data.id,
                            ...data.source
                        }
                    })
                }

                const listData = await request({
                    url: "dataSource/getData",
                    data: {id: dataSource.id, pageSize: previewRows || 25},
                    method: "POST"
                });
                const generatedData = await this.setListData(listData, previewRows);
                this.setState({
                    loading: false,
                    listData: {...listData, ...generatedData.content},
                    pivotData: generatedData.pivotData,
                    pivotGeneratedColumns: generatedData.pivotColumns
                })
            } catch (err) {
                this.setState({loading: false});
                const errMessage = getSafe(() => err.data.status.message[0].text, 'Get Data Error!');
                enqueueSnackbar(errMessage, {variant: 'error'});
                console.log(err)
            }
        }

    }

    loadSampleData() {
        this.setState({
            loadedSampleData: true
        })
    }

    saveList = async () => {
        const {data} = this.state;
        const {enqueueSnackbar, modal, setNewList, location: {pathname, state = {}}, history} = this.props;
        try {
            const response = await request({
                url: 'list/update',
                method: 'POST',
                data: {...data}
            });
            enqueueSnackbar(successMessage(response.id, history, pathname, state.prevState), {variant: `success`});
            if (modal) {
                setNewList(data.id)
            }
            this.setState({isChanged: false});
            this.closeList(false);
        } catch (err) {
            console.log(err);
            let message = getSafe(() => err.data.status.message[0].text, 'Error');
            enqueueSnackbar(message, {variant: 'error'});
        }
    };

    deleteList = () => {
        const {
            location: {state: {fieldValuesId} = {}} = {},
            match: {params: {id} = {}} = {},
            enqueueSnackbar
        } = this.props;
        const recordId = id ? id : fieldValuesId ? fieldValuesId : null;
        request({
            url: 'list/delete',
            method: 'POST',
            data: {id: recordId}
        }).then(() => {
            enqueueSnackbar('Success', {variant: 'success'});
            this.closeList();
        }).catch(err => {
            console.log(err);
            let message = getSafe(() => err.data.status.message[0].text, 'Error');
            enqueueSnackbar(message, {variant: 'error'});
        })
    };

    closeList = (showConfirmation = true) => {
        const {history, location: {state = {}}, modal, onClose} = this.props;
        const {isChanged} = this.state;
        const isShow = isChanged && showConfirmation;
        if (modal) {
            if (isShow) {
                this.openConfirmation(
                    'You have unsaved information, are you sure ?',
                    'Yes',
                    'No',
                    () => {
                        onClose()
                    }
                );
            } else {
                onClose()
            }
        } else {
            if (state.prevPath) {
                if (isShow) {
                    this.openConfirmation(
                        'You have unsaved information, are you sure ?',
                        'Yes',
                        'No',
                        () => {
                            history.push({
                                pathname: state.prevPath,
                                state: {prevListState: state.prevListState}
                            })
                        }
                    );
                } else {
                    history.push({
                        pathname: state.prevPath,
                        state: {prevListState: state.prevListState}
                    });
                }
            } else {
                if (isShow) {
                    this.openConfirmation(
                        'You have unsaved information, are you sure ?',
                        'Yes',
                        'No',
                        () => history.goBack()
                    );
                } else {
                    history.goBack();
                }
            }
        }

    };

    //change fields handlers
    generalInfoChange = async (event, path, isCheckBox) => {
        const {data} = this.state;
        const newData = set(data, path, isCheckBox === true ? event.target.checked : event.target.value);
        this.setState({data: newData, isChanged: true});
        if (path === 'transposeData') {
            await this.updateListData()
        }
    };

    generalInfoChangeAutoComplete = (value, name) => {
        const {data} = this.state;
        const newData = set(data, `${name}`, value);
        this.setState({data: newData, isChanged: true})
    };

    previewRowsChange = (event) => {
        const {initialData, data: {source: {type}}} = this.state;
        let {target: {value: previewRows}} = event;
        let generatedData = this.setListData(initialData, previewRows.length === 0 ? 25 : previewRows);
        this.setState(state => ({
            data: {...state.data, devSettings: {previewRows}},
            listData: {...state.listData, ...generatedData.content},
            pivotData: generatedData.pivotData,
            pivotGeneratedColumns: generatedData.pivotColumns
        }), async () => {
            //is type entity , updateListData with new pageSize
            if (type === 'ENTITY') {
                await this.updateListData();
            }
        })
    };

    dataSourceChange = (event, path, isCheckBox) => {
        const {data} = this.state;
        const newData = set(data, `source.${event.target.name}`, isCheckBox === true ? event.target.checked : event.target.value);
        this.setState({data: newData, isChanged: true})
    };
    dataSourceSetConnection = (values) => {
        const {data} = this.state;
        const newData = set(data, `source`, values);
        this.setState({data: newData, isChanged: true})
    };

    saveQuery = async (query) => {
        const {data} = this.state;
        const newData = set(data, `source.query`, query);
        this.setState({data: newData, isChanged: true}, async () => {
            await this.getQueryColumns()
        });
    };

    gridChange = (event, path, isCheckBox) => {
        const {data} = this.state;
        const newData = set(data, `gridProps.${event.target.name}`, isCheckBox === true ? event.target.checked : event.target.value);
        this.setState({data: newData, isChanged: true})
    };
    gridChangeSumSelectedFields = (value, path) => {
        const {data} = this.state;
        const newData = set(data, path, value);
        this.setState({data: newData, isChanged: true})
    };

    chartChange = (event, path, isCheckBox) => {
        const {data} = this.state;
        const newData = set(data, `chartProps.${event.target.name}`, isCheckBox === true ? event.target.checked : event.target.value);
        this.setState({data: newData, isChanged: true})
    };
    chartChangeAutoComplete = (value, name) => {
        const {data} = this.state;
        const newData = set(data, `chartProps.${name}`, value);
        this.setState({data: newData, isChanged: true})
    };
    chartChangeSeries = (value) => {
        const {data} = this.state;
        let isPresent = _.findIndex(data.chartProps.series, (e) => {
            return e.column === value
        });
        if (isPresent !== -1) {
            this.setState({currentSerie: {...data.chartProps.series[isPresent], index: isPresent}})
        } else {
            const newData = push(data, 'chartProps.series', {column: value, color: ''});
            this.setState({
                data: newData,
                currentSerie: {column: value, color: '', index: newData.chartProps.series.length - 1}
            })
        }
    };
    chartChangeSeriesPie = (value) => {
        console.log(value)
    };
    changeSerieColor = (color, name, path) => {
        const {data} = this.state;
        const newData = set(data, path, color);
        this.setState(state => ({data: newData, currentSerie: {...state.currentSerie, color: color}}))
    };
    changeSerieStyle = (style, name, path) => {
        const {data} = this.state;
        const newData = set(data, path, style);
        this.setState(state => ({data: newData, currentSerie: {...state.currentSerie, style}}))
    };
    changeSerieType = (type, name, path) => {
        const {data} = this.state;
        const newData = set(data, path, type);
        this.setState(state => ({data: newData, currentSerie: {...state.currentSerie, type}}))
    };
    chartPropsChange = (event, path, isCheckBox) => {
        const {data} = this.state;
        const newData = set(data, path, isCheckBox === true ? event.target.checked : event.target.value);
        this.setState({data: newData, isChanged: true})
    };
    chartPropsChangeAutoComplete = (value, name, path) => {
        const {data} = this.state;
        const newData = set(data, path, value);
        this.setState({data: newData, isChanged: true})
    };
    chartPropsChangeColor = (color, name, path) => {
        const {data} = this.state;
        const newData = set(data, path, color);
        this.setState({data: newData})
    };
    onChangePivotGrandTotal = (path, values) => {
        const {data} = this.state;
        const newData = set(data, 'pivot.grandTotal.' + path, values);
        this.setState({data: newData})
    }
    setTitleStyles = (styles) => {
        const {data} = this.state;
        const newValues = set(data, 'chartProps.title.styles', styles);
        this.setState({data: newValues})
    };
    setColumns = async (columns, filterColumns, sortColumns, rowsColumns, valuesColumns, pivotColumns, predefinedFilter) => {
        const {data} = this.state;
        const values = {
            columns,
            predefinedFilter,
            filterFields: filterColumns,
            sort: sortColumns,
            rows: rowsColumns,
            values: valuesColumns,
            pivotColumns: pivotColumns
        };
        const newData = set(data, '', {...data, ...values});
        let source = await checkDataSource(data.id);

        if (source) {
            try {
                source = await request({
                    url: "/dataSource/update",
                    data: {
                        ...source,
                        ...values,
                        paged: data.source?.paged,
                    }
                })
            } catch (e) {
                source = {
                    ...source,
                    ...values,
                    paged: data.source?.paged,
                }
            }
        } else if (data.id && data.source) {
            try {
                source = await request({
                    url: "/dataSource/create",
                    data: {
                        id: data.id,
                        ...data.source,
                        ...values,
                    }
                })
            } catch (e) {
                source = {
                    id: data.id,
                    ...data.source,
                    ...values,
                }
            }

        }

        this.setState({data: {...newData, source}, isChanged: true}, () => {
            this.updateListData();
        })
    };


    //helper functions
    openConfirmation = (text, submitLabel, cancelLabel, submitFn) => {
        this.setState({
            confirmationDialog: {
                open: true,
                text,
                submitLabel,
                cancelLabel,
                submitFn: () => {
                    this.setState({isChanged: false, confirmationDialog: {open: false}});
                    submitFn()
                },
                cancelFn: this.setState({confirmationDialog: {open: false}}),
            }
        })
    };
    openConfirmationBeforeDelete = () => {
        this.openConfirmation(
            'Do you want to delete this list?',
            'Yes',
            'No',
            () => {
                this.deleteList()
            }
        );
    };

    render() {
        const {classes, modal} = this.props;
        const {
            errorComponent,
            loading,
            loadingData,
            schema,
            pivot,
            data,
            listData,
            columns,
            confirmationDialog,
            pivotGeneratedColumns,
            pivotData,
            currentSerie,
        } = this.state;
        return (
            <>
                {loading && <Loading/>}
                {errorComponent ? (
                    <div>Something bad with ListDesigner</div>
                ) : (
                    <ListDesignerProvider
                        value={{
                            schema: schema,
                            data: data,
                            listData: listData,
                            columns: columns,
                            pivotGeneratedColumns: pivotGeneratedColumns,
                            pivotData: pivotData,
                            modal: modal,
                            currentSerie: currentSerie,
                            onChangePivotGrandTotal: this.onChangePivotGrandTotal,
                            saveList: this.saveList,
                            deleteList: this.openConfirmationBeforeDelete,
                            closeList: this.closeList,
                            updateListData: this.updateListData,
                            generalInfoChange: this.generalInfoChange,
                            generalInfoChangeAutoComplete: this.generalInfoChangeAutoComplete,
                            previewRowsChange: this.previewRowsChange,
                            dataSourceChange: this.dataSourceChange,
                            dataSourceSetConnection: this.dataSourceSetConnection,
                            gridChange: this.gridChange,
                            gridChangeSumSelectedFields: this.gridChangeSumSelectedFields,
                            chartChange: this.chartChange,
                            chartChangeAutoComplete: this.chartChangeAutoComplete,
                            chartPropsChange: this.chartPropsChange,
                            chartPropsChangeAutoComplete: this.chartPropsChangeAutoComplete,
                            chartPropsChangeColor: this.chartPropsChangeColor,
                            chartChangeSeries: this.chartChangeSeries,
                            chartChangeSeriesPie: this.chartChangeSeriesPie,
                            changeSerieColor: this.changeSerieColor,
                            changeSerieStyle: this.changeSerieStyle,
                            changeSerieType: this.changeSerieType,
                            setColumns: this.setColumns,
                            getColumns: this.getColumns,
                            saveQuery: this.saveQuery,
                            setTitleStyles: this.setTitleStyles,
                            loadSampleData: this.loadSampleData,
                            loadedSampleData: this.state.loadedSampleData
                        }}
                    >
                        {confirmationDialog.open && (
                            <Confirmation
                                open={confirmationDialog.open}
                                submitLabel={confirmationDialog.submitLabel}
                                cancelLabel={confirmationDialog.cancelLabel}
                                close={() => this.setState({confirmationDialog: {open: false}})}
                                submit={confirmationDialog.submitFn}
                            >
                                {confirmationDialog.text}
                            </Confirmation>
                        )}
                        <div className={classes.rootPaper}>
                            <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                                <ToolBar/>
                            </div>
                            <div className={classes.screenBarWrapper} style={{position: 'relative'}}>
                                {loadingData && <Loading zIndex={999} size={20}/>}
                                <ScreenBar/>
                            </div>
                        </div>
                    </ListDesignerProvider>
                )}
            </>
        )
    }
}

export default withSnackbar(withStyles(styles)(ListDesigner));
